import { Injectable } from '@angular/core';
import ArrayHelpers from '../ArrayHelper';
import { BeneficiaryDelete, BeneficiaryDeleteResult } from '../Models/beneficiary-delete.interface';
import { PersonTypeString } from '../Models/const.personType';



interface BeneficiariesListAndBeneficiariesMapped  {
  beneficiaryList: models.BeneficiaryListVM[];
  beneficiariesMapped: BeneficiaryDelete[];
}
 

@Injectable({ providedIn: "root" })

export class BeneficiaryDeleteService {

 

  public removeBeneficiaryFromList(
    item: models.BeneficiaryListVM,
    beneficiaryList: models.BeneficiaryListVM[],
    documentsList: models.DocumentPM_VM[]): BeneficiaryDeleteResult {
      //Verify if sender exist, and if so, remove it temporary from the beneficiaries list 
    const senderItem = beneficiaryList.find(el => el.beneficiaryID === 1);
    const senderExist = senderItem != null && senderItem != undefined;
    if (senderExist) {
      beneficiaryList = this.removeSenderFromList(senderItem, beneficiaryList);
    }

    let beneficiariesMapped: BeneficiaryDelete[] = this.mapBeneficariosIds(beneficiaryList);
    const toRemoveIndex = this.getIndexOfItem(item, beneficiaryList);
    beneficiaryList.splice(toRemoveIndex, 1);

    const beneficiariesResult = this.updateBeneficiaryListIds(beneficiaryList, beneficiariesMapped);

    beneficiaryList = beneficiariesResult.beneficiaryList;
    beneficiariesMapped = beneficiariesResult.beneficiariesMapped;
    documentsList = this.removeDocumentsFromRepresentado(item, documentsList);


    documentsList = this.updateDocumentsBeneficiariesIds(documentsList, beneficiariesMapped);

    if (senderExist) {
      beneficiaryList = this.addSenderFromList(senderItem, beneficiaryList);
    }

    const result: BeneficiaryDeleteResult = {
      beneficiaryList,
      documentsList
    };

    return result;
  }


  addSenderFromList(senderItem: models.BeneficiaryListVM, beneficiaryList: models.BeneficiaryListVM[]): models.BeneficiaryListVM[] {
    const result = [senderItem, ...beneficiaryList];
    return result;
  }

  removeSenderFromList(senderItem: models.BeneficiaryListVM, beneficiaryList: models.BeneficiaryListVM[]): models.BeneficiaryListVM[] {
    const indexOfElement = beneficiaryList.findIndex(el => el.beneficiaryID === senderItem.beneficiaryID);
    beneficiaryList.splice(indexOfElement, 1);
    return beneficiaryList;
  }


  private mapBeneficariosIds(beneficiaryList: models.BeneficiaryListVM[]): BeneficiaryDelete[] {
    const beneficiariesToDelete = [...beneficiaryList];
    const result = beneficiariesToDelete.map(ben => {
      const benToDelete: BeneficiaryDelete = {
        oldId: ben.beneficiaryID,
        nif: ben.NIF,
        name: ben.beneficiaryName
      };
      return benToDelete;
    });
    return result;
  }

  private updateBeneficiaryListIds(
    beneficiaryList: models.BeneficiaryListVM[],
    beneficiariesMapped: BeneficiaryDelete[]): BeneficiariesListAndBeneficiariesMapped {
    beneficiaryList.sort((benA, benB) => benA.beneficiaryID - benB.beneficiaryID);
    let idNew = 2;
    beneficiaryList.forEach((ben, idx) => {
      const oldId = ben.beneficiaryID;
      ben.beneficiaryID = idNew++;
      const newBenMap = beneficiariesMapped.find(benMap => benMap.oldId === oldId);
      newBenMap.newId = ben.beneficiaryID;
    });

    const result: BeneficiariesListAndBeneficiariesMapped = {
      beneficiariesMapped,
      beneficiaryList
    }
  
    return result;
  }


  private removeDocumentsFromRepresentado(beneficiario: models.BeneficiaryListVM,
    documentsList: models.DocumentPM_VM[]): models.DocumentPM_VM[] {
    const toRemove=documentsList?.filter(doc => 
      doc.beneficiaryID == beneficiario.beneficiaryID &&
        doc.fileOwnerTypeCode == PersonTypeString.Beneficiary
    )
    documentsList = ArrayHelpers.removeItems(documentsList,toRemove) ;
    return documentsList;
  }

  private updateDocumentsBeneficiariesIds(documentsList: models.DocumentPM_VM[],
    beneficiariesMappedIDs: BeneficiaryDelete[]): models.DocumentPM_VM[] {
    const result = documentsList.map(doc => {
      const docToReturn = doc;
      const beneficiaryMapppedId = beneficiariesMappedIDs.find(el => el.oldId == doc.beneficiaryID);
      if (beneficiaryMapppedId != null && beneficiaryMapppedId != undefined) {
        docToReturn.beneficiaryID = beneficiaryMapppedId.newId;
      }
      return docToReturn;

    });
    return result;

  }

  private getIndexOfItem(item: models.BeneficiaryListVM, beneficiaryList: models.BeneficiaryListVM[]): number {
    let result = null;
    for (let i = 0; i < beneficiaryList.length; i++) {
      if (beneficiaryList[i].NIF == item.NIF && beneficiaryList[i].beneficiaryID === item.beneficiaryID) {
        result = i;
        break;
      }
    }
    return result;
  }
}

